import { BcfLitElement } from '@bcf2-shared-pkg-v1/ui/shared/classes/bcf-lit-element';
import { Subscription, SubscriptionLike } from 'rxjs';

export abstract class UnsubscribableBcfLitElement extends BcfLitElement {
  private _subscriptions: Subscription = new Subscription();

  set _sub(sub: SubscriptionLike | undefined) {
    if (Boolean(sub)) {
      this._subscriptions.add(sub);
    }
  }

  public override connectedCallback(): void {
    super.connectedCallback();
    this._subscriptions = new Subscription();
  }

  public override disconnectedCallback(): void {
    super.disconnectedCallback();
    this._subscriptions.unsubscribe();
  }
}
